export function replace_placeholder_token(obj) {
  var old_text = jQuery(obj).html();
  var new_text = old_text.replace(/\{([A-Z_][\w\-]*)\}(?![^\<]*\>)/gi, '<a href="#" class="placeholder-token">$1&nbsp;</a>');
  jQuery(obj).html(new_text);
}
